import React, { createContext, useContext, useState, useMemo } from 'react';

const AllThingsListsContext = createContext();

export const AllThingsListsProvider = ({ children }) => {
  // 🔹 State variables
  const [quickList, setQuickList] = useState([]);
  const [quickListNumbers, setQuickListNumbers] = useState([]);
  const [isListPillFiltered, setisListPillFiltered] = useState(false);
  const [isListFiltered, setisListFiltered] = useState(false);
  const [filterBoxValue, setFilterBoxValue] = useState("");
  const [filterBoxDropdown, setFilterBoxDropdown] = useState("All");

  // 🔹 Update functions
  const updateQuickList = (id) => setQuickList(id);

  // ✅ ALWAYS store as array of strings
  const updateQuickListNumbers = (nums) => {
    const normalized = Array.isArray(nums) ? nums.map(v => String(v)) : [];
    setQuickListNumbers(normalized);
  };

  const updateIsListFiltered = (boolean) => setisListFiltered(boolean);
  const setIsListPillFiltered = (boolean) => setisListPillFiltered(boolean);
  const updateFilterBoxValue = (value) => setFilterBoxValue(value);
  const updateFilterBoxDropdown = (value) => setFilterBoxDropdown(value);

  // 🔹 Memoized values & functions
  const memoizedState = useMemo(() => ({
    quickList,
    quickListNumbers,
    isListFiltered, // this is used to set when the Filter Box has a value
    isListPillFiltered,
    filterBoxValue,
    filterBoxDropdown,
  }), [quickList, quickListNumbers, isListFiltered, isListPillFiltered, filterBoxValue, filterBoxDropdown]);

  const memoizedActions = useMemo(() => ({
    updateQuickList,
    updateQuickListNumbers,
    setIsListPillFiltered,
    updateIsListFiltered,
    updateFilterBoxValue,
    updateFilterBoxDropdown,
  }), []);

  return (
    <AllThingsListsContext.Provider value={{ ...memoizedState, ...memoizedActions }}>
      {children}
    </AllThingsListsContext.Provider>
  );
};

export const useAllThingsLists = () => {
  const context = useContext(AllThingsListsContext);
  if (!context) {
    throw new Error('useAllThingsLists must be used within an AllThingsListsProvider');
  }
  return context;
};
